/** How often the app checks whether a newer build has been deployed. */
export const VERSION_CHECK_INTERVAL_MS = 30_000;
